import { GlobalStylesOverride, Privacy } from "gis-website";
import { NextPage } from "next";
import { NextSeo } from "next-seo";
import { useSendCurrentPageViewEvent } from "tag-manager";

const PrivacyPage: NextPage = () => {
	useSendCurrentPageViewEvent();
	return (
		<>
			<NextSeo
				title="Mango GIS - Privacy"
				description="Legal information about Privacy"
			/>
			<GlobalStylesOverride />
			<Privacy />
		</>
	);
};

export default PrivacyPage;
